import { createDataStore } from "./common";

export default createDataStore({
  storeKey: "sources",
  endpoint: process.env.REACT_APP_PLACES_API_HOST + "/sources",
  idKey: "mn_source_id"
});
